import { createSelector } from "reselect";
import { selectRoot } from "./base";

export const selectProductOutfitAvailability = createSelector(
  selectRoot,
  (rootReducer) => {
    return rootReducer.pdp.outfit?.productOutfitAvailability ?? {};
  }
);
